import type { ColorOption } from '../types/category';

/** Palette courante pour objets trouvés / perdus (sacs, vêtements, téléphones…). */
export const BASE_CATEGORY_COLOR_OPTIONS: ColorOption[] = [
  { label: 'Noir', hex: '#000000' },
  { label: 'Blanc', hex: '#FFFFFF' },
  { label: 'Gris', hex: '#9E9E9E' },
  { label: 'Gris clair', hex: '#E0E0E0' },
  { label: 'Argent', hex: '#B0BEC5' },
  { label: 'Doré', hex: '#C9A227' },
  { label: 'Beige', hex: '#D7CCC8' },
  { label: 'Marron', hex: '#6D4C41' },
  { label: 'Rouge', hex: '#E53935' },
  { label: 'Bordeaux', hex: '#7B1F32' },
  { label: 'Rose', hex: '#EC407A' },
  { label: 'Orange', hex: '#FB8C00' },
  { label: 'Jaune', hex: '#FDD835' },
  { label: 'Vert', hex: '#43A047' },
  { label: 'Bleu', hex: '#1E88E5' },
  { label: 'Bleu marine', hex: '#1565C0' },
  { label: 'Violet', hex: '#8E24AA' },
  { label: 'Turquoise', hex: '#26A69A' },
  { label: 'Multicolore', hex: null },
  { label: 'Autre', hex: null },
];

export function cloneBaseCategoryColorOptions(): ColorOption[] {
  return BASE_CATEGORY_COLOR_OPTIONS.map((option) => ({ ...option }));
}

function normalizeColorLabel(label: string): string {
  return label.trim().toLowerCase();
}

/** Ajoute les couleurs de base absentes (comparaison sur le libellé). */
export function mergeBaseCategoryColorOptions(
  current: ColorOption[]
): ColorOption[] {
  const existing = new Set(
    current.map((option) => normalizeColorLabel(option.label || '')).filter(Boolean)
  );
  const merged = [...current];
  for (const base of BASE_CATEGORY_COLOR_OPTIONS) {
    const key = normalizeColorLabel(base.label);
    if (!key || existing.has(key)) {
      continue;
    }
    merged.push({ ...base });
    existing.add(key);
  }
  return merged;
}

export function hasBaseCategoryColorOptions(options: unknown): boolean {
  return Array.isArray(options) && options.length > 0;
}
